define([
    "angular",
    "../nlgTable/nlgTable",
    "../templateFactory/templateFactory"
], function (angular) {
    return angular.module("nlgTableDynamicColumnsModule", ["nlgTableModule", "templateFactoryModule"]);
});